export default "__VITE_ASSET__5678ac8d__"